module.exports = __webpack_public_path__ + "static/media/huangxinchun.9768763b.png";